export const WhoWeAreUserTypes = {
  Initiator: "Initiator",
  EarlySupporter: "Early Supporter",
  TechAdvisor: "Tech Advisor",
  CorporatePartner: "Corporate Partner",
  TechDeveloper: "Tech Developer",
  ManagementAdvisor: "Management Advisor",
};
